import gql from 'graphql-tag'
import { listCreditClients } from './fragments'

export default gql`
query listCreditClients($params: ListQueryArgs $filter: CreditClientsFilter) {
	cashAssist {
		listCreditClients(params: $params, filter: $filter) {
			...listCreditClients
		}
	}
}
${listCreditClients}
`
